import { AuthReducer } from '@infobis/as-react-auth';

import dashExpenses from './dashboard/expenses';
import dashCrops from './dashboard/crops';
import dashCropsCondition from './dashboard/cropscondition';
import dashWorks from './dashboard/works';
import dashCropDetalization from './dashboard/crops/detalization';
import dashExpensesDetalization from './dashboard/expenses/detalization';
import workDetalization from './dashboard/works/detalization';
import efficiencyDetalization from './dashboard/works/efficiency';
import idlesDetalization from './dashboard/works/idles';
import worksByDepartmentsAndCrops from './dashboard/works/byDepartmentsAndCrops';
import weather from './weather/';

import applicationSettings from './settings';
import mapTabSettings from './map/settings/mapTab';
import geoZoneTabSettings from './map/settings/geoZonesTab';
import markersTabSettings from './map/settings/markersTab';
import pixiSettings from './map/settings/pixi';
import cropSelector from './dashboard/crops/selector';
import phases from './dashboard/phases';
import ndvi from './dashboard/ndvi';
import geoZones from './geoZones';
import units from './units';
import operations from './references/operations';
import organizations from './references/organizations';
import goods from './partners/goods/index';
import users from './partners/users';

import fields from './fields';
import selectedDate from "./dashboard/date";
import vehiclesStatuses from './dashboard/vehicles/statuses';
import vehiclesTypes from './dashboard/vehicles/types';

export default {
  auth: AuthReducer,
  weather,
  fields,
  geoZones,
  units,
  //====================>
  dashExpenses,
  dashExpensesDetalization,
  dashCrops,
  dashCropsCondition,
  dashWorks,
  dashCropDetalization,
  workDetalization,
  efficiencyDetalization,
  idlesDetalization,
  worksByDepartmentsAndCrops,
  vehiclesStatuses,
  vehiclesTypes,
  //====================>
  cropSelector,
  mapTabSettings,
  geoZoneTabSettings,
  markersTabSettings,
  phases,
  pixiSettings,
  //====================>
  // References
  ndvi,
  selectedDate,
  operations,
  organizations,
  applicationSettings,
  //====================>
  //Partners
  goods,
  users,
}

// индексовый файл, в который экспортируются все reducers и экспортируются объектом.
// нужен для того, чтобы не захламлять вызов combineReducers и не захламлять логику там.